import { Instance } from 'mobx-state-tree'
import { ChapterUserProgressModelBase } from './ChapterUserProgressModel.base'

/* The TypeScript type of an instance of ChapterUserProgressModel */
export interface ChapterUserProgressModelType extends Instance<typeof ChapterUserProgressModel.Type> {}

/* A graphql query fragment builders for ChapterUserProgressModel */
export {
  selectFromChapterUserProgress,
  chapterUserProgressModelPrimitives,
  ChapterUserProgressModelSelector
} from './ChapterUserProgressModel.base'

/**
 * ChapterUserProgressModel
 */
export const ChapterUserProgressModel = ChapterUserProgressModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
